exports.components = {
  "component---src-pages-404-js": () => import("./../../../src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */),
  "component---src-templates-essay-detail-js": () => import("./../../../src/templates/essay-detail.js" /* webpackChunkName: "component---src-templates-essay-detail-js" */),
  "component---src-templates-work-detail-js": () => import("./../../../src/templates/work-detail.js" /* webpackChunkName: "component---src-templates-work-detail-js" */)
}

